"use client";

import { usePostHog } from "posthog-js/react";

type Props = {
	locale: "id" | "en";
	jobId?: string;
};

/**
 * In-page "apply" control shown under the job FAQ's how-to-apply answer.
 * The answer text tells visitors to click "Lamar"; on its own it drew dead
 * clicks (replay 01a0d16d, 2026-09-24). Moving focus alone still looked dead
 * to a mouse user (no focus ring on a pointer click): replay 01a1627d,
 * 2026-10-31, clicked it 3 times in 6 s. So it now runs the real apply CTA.
 */
export function FaqApplyLink({ locale, jobId }: Props) {
	const posthog = usePostHog();

	function onClick() {
		posthog?.capture("faq_apply_link_clicked", { job_id: jobId, locale });
		const isMobile = window.matchMedia("(max-width: 1023.98px)").matches;
		const root = isMobile
			? document.querySelector('[data-testid="job-apply-fixed-footer"]')
			: document.getElementById("apply");
		if (!isMobile)
			root?.scrollIntoView?.({ behavior: "smooth", block: "center" });
		const target =
			root?.querySelector<HTMLElement>('[data-testid="job-apply-cta"]') ??
			root?.querySelector<HTMLElement>("button, a[href]");
		target?.focus({ preventScroll: true });
		target?.click();
	}

	return (
		<button
			type="button"
			onClick={onClick}
			className="mt-2 block w-fit text-left rounded-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
		>
			{locale === "id" ? "Lamar sekarang →" : "Apply now →"}
		</button>
	);
}
